import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./css/nav.css";
import logo from "../images/وزارة الصحة تونس2.png"; 

function Nav() {
  const [isOpen, setIsOpen] = useState(false); 

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="all-nav">
        <div className="btton">
        <button 
  className="contact-btn" 
  onClick={() => window.open('https://wa.me/53793401', '_blank')}
>
  اتصل بنا
</button>


        </div>
        <div className={`links ${isOpen ? "open" : ""}`}> {/* Add the 'open' class when isOpen is true */}
          <ul>
            <li><Link to="/">الرئيسية</Link></li>
            <li><Link to="/about">من أنا</Link></li>
            <li><Link to="/services">الخدمات</Link></li>
            <li><Link to="/blog">المدونة</Link></li>
            <li><Link to="/projects">المشاريع</Link></li>
            <li><Link to="/addnew"></Link></li> {/* Added new link here */}
          </ul>
        </div>
       
        {/* Burger Icon */}
        <div className="burger" onClick={toggleMenu}>
          <div className={`line1 ${isOpen ? "toggle" : ""}`}></div>
          <div className={`line2 ${isOpen ? "toggle" : ""}`}></div>
          <div className={`line3 ${isOpen ? "toggle" : ""}`}></div>
        </div>
      </div>
    </>
  );
}

export default Nav;
